module.exports = __webpack_public_path__ + "06_long_brown.b47a92ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/06_long_brown.png
// module id = N/uw
// module chunks = 0